import React, { useEffect, useState } from "react";
import {
  Card,
  Button,
  Spin,
  Divider,
  Descriptions,
  Image,
  Empty,
  Modal,
  Tag,
  Rate,
  Grid,
} from "antd";
import {
  ArrowLeftOutlined,
  UserOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { URL } from "../config";

export default function TechnicianDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [data, setData] = useState(null);
  const [rating, setRating] = useState(null);

  const [loading, setLoading] = useState(true);
  const [ratingLoading, setRatingLoading] = useState(true);

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    const fetchTechnician = async () => {
      try {
        const res = await axios.get(`${URL}/technicians/${id}`);
        setData(res.data);

        const ratingRes = await axios.get(
          `${URL}/technicians/rating/${id}`
        );
        setRating(ratingRes.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
        setRatingLoading(false);
      }
    };

    fetchTechnician();
  }, [id]);

  const renderImage = (img) => {
    if (!img) return <Empty description="No image available" />;

    const src = img.startsWith("http") ? img : `${URL}${img}`;

    return (
      <Image
        src={src}
        preview={false}
        style={{
          width: "100%",
          maxWidth: 180,
          height: "auto",
          objectFit: "cover",
          borderRadius: 12,
          cursor: "pointer",
          boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
        }}
        onClick={() => {
          setPreviewImage(src);
          setPreviewVisible(true);
        }}
      />
    );
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 120,
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!data) return <Empty description="Technician not found" />;

  return (
    <div
      style={{
        padding: screens.xs ? 12 : 24,
        background: "#f4f6f8",
        minHeight: "100vh",
      }}
    >
      <Card
        style={{
          maxWidth: 1200,
          margin: "auto",
          borderRadius: 18,
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
        }}
      >
   
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <h2 style={{ fontWeight: 700, margin: 0 }}>
            Technician Details
          </h2>

          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>

       
        <Card
          title="Basic Information"
          style={{
            marginBottom: 20,
            borderRadius: 12,
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}
        >
          <Descriptions
            bordered
            column={screens.xs ? 1 : 2}
            size="small"
          >
            <Descriptions.Item label="Technician ID">
              {data.technicianId}
            </Descriptions.Item>

            <Descriptions.Item label="Technician Name">
              {data.technicianName || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Mobile No">
              {data.mobileNo || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Alternate Mobile">
              {data.alternateMobileNo || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Address" span={2}>
              {data.address || "-"}
            </Descriptions.Item>
          </Descriptions>
        </Card>

   
        <Card
          title="Customer Rating"
          style={{
            marginBottom: 20,
            borderRadius: 12,
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}
        >
          {ratingLoading ? (
            <Spin />
          ) : rating && rating.success ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              <Rate allowHalf disabled value={rating.averageRating} />
              <Tag color="blue">
                {rating.totalRatings} Ratings
              </Tag>
            </div>
          ) : (
            <Empty description="No ratings available" />
          )}
        </Card>

        <Divider />

     
        <h3>
          <UserOutlined /> Profile Photo
        </h3>
        <Card style={{ marginBottom: 20 }}>
          {renderImage(data.profilePhoto)}
        </Card>

        <h3>
          <IdcardOutlined /> Aadhar Image
        </h3>
        <Card style={{ marginBottom: 20 }}>
          {renderImage(data.aadharImg)}
        </Card>

    
        <h3>Other Image</h3>
        <Card>{renderImage(data.otherImg)}</Card>

    
        <Modal
          open={previewVisible}
          footer={null}
          onCancel={() => setPreviewVisible(false)}
        >
          <img
            src={previewImage}
            alt="preview"
            style={{
              width: "100%",
              borderRadius: 14,
            }}
          />
        </Modal>
      </Card>
    </div>
  );
}
